import { useEffect, useState } from 'react';
import { getHealthSystems } from '../../../utils/api';
import { findSystemBySlug, mapSystemsResponse } from '../utils/systemUtils';

const useResolvedSystem = (systemSlug, initialSystem) => {
  const [system, setSystem] = useState(initialSystem ?? null);
  const [loading, setLoading] = useState(Boolean(!initialSystem && systemSlug));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (initialSystem) {
      setSystem(initialSystem);
      setLoading(false);
      setError(null);
      return;
    }

    if (!systemSlug) {
      setSystem(null);
      setLoading(false);
      setError(null);
      return;
    }

    let isMounted = true;

    const resolveSystemFromSlug = async () => {
      setSystem(null);
      setLoading(true);
      setError(null);

      try {
        const response = await getHealthSystems();
        const formattedSystems = mapSystemsResponse(response);

        if (!isMounted) {
          return;
        }

        const matchingSystem = findSystemBySlug(formattedSystems, systemSlug);

        if (matchingSystem) {
          setSystem(matchingSystem);
        } else {
          setSystem(null);
          setError('Health system not found. Please return to selection.');
        }
      } catch (err) {
        if (!isMounted) {
          return;
        }

        console.error('Error resolving health system from slug:', err);
        setSystem(null);
        setError(err.message || 'Failed to load health system.');
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    resolveSystemFromSlug();

    return () => {
      isMounted = false;
    };
  }, [systemSlug, initialSystem]);

  return { system, loading, error };
};

export default useResolvedSystem;
